let $elements = $('.js-upload-avatar');
let $img = $('.js-file-avatar');
let $errorFancyBox = $('[data-fancybox="avatar-message"]');
let circleClass = 'profile-card__avatar--circle';

$elements.change(function(){
	
	let file = this.files[0];
	
	if(typeof file === 'undefined') return false;
	
	if(!file.type.match(/image.*/)) {
		$.fancybox.open('Файл не является изображением');
		return false;
	}
	
	let formData = new FormData();
	
	formData.append('PERSONAL_PHOTO', file);
	
	$.ajax({
		url: "/profile/",
		type: "POST",
		data: formData,
		dataType: "json",
		processData: false,
		contentType: false,
		success: function(data){
			
			if(data.status == 'true'){
				
				let reader = new FileReader();
				reader.readAsDataURL(file);
				reader.onloadend = function (e) {
					$img.attr('src',e.target.result);
					$img.addClass(circleClass);
				}
				
				ym(METRIKA_COUNTER_ID,'reachGoal','change_avatar_success');
				
			}else if(data.status == 'false'){
				
				$.fancybox.open(data.message);
				ym(METRIKA_COUNTER_ID,'reachGoal','change_avatar_fail');
				
			}else{
				$.fancybox.open('Ошибка выполнения операции');
				ym(METRIKA_COUNTER_ID,'reachGoal','change_avatar_fail');
			}
			
			
			
		},
		error: function(){
			$.fancybox.open('Ошибка сервера. Повторите операцию позже');
			ym(METRIKA_COUNTER_ID,'reachGoal','change_avatar_fail');
		},
	})
	
});